import { FormGroup, Input, Label } from "reactstrap";
import { useAuth } from "../../../context";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { API_URL } from "../../../utils/constants";
import DefaultButton from "../../../components/Buttons/Default";
import { toast } from "react-toastify";
import { useTranslation } from "react-i18next";

function RegisterForm() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { handleLogin } = useAuth();
  const [isLoading, setIsLoading] = useState(false);
  const [userData, setUserData] = useState({
    name: "",
    phoneNumber: "",
    password: ""
  });

  const register = async () => {
    setIsLoading(true);
    const response = await fetch(API_URL+'/register', {
      method: 'POST',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        name: userData.name,
        phone_number: userData.phoneNumber,
        password: userData.password
      }),
    });
    const data = await response.json();      
    if (data.success) {
      if (window.ReactNativeWebView) {
        window.ReactNativeWebView.postMessage(
          JSON.stringify({
            type: 'user-id',
            userId: data.user.id,
            token: data.token
          })
        );
      }
      
      handleLogin(data);
      if(data.user.phone_verified_at) {
        navigate("/");
      } else {
        navigate('/otp');
      }
    } else {
      toast.error(data.message || "حدث خطأ أثناء التسجيل");
    }
    setIsLoading(false);
  }

  return(
    <div>
      <FormGroup>
        <Label>{ t('auth.tabs.register.fields.fullname.label') }: </Label>
        <Input 
          type="text" 
          placeholder={ t('auth.tabs.register.fields.fullname.placeholder') } 
          value={userData.name}
          onChange={(e) => setUserData({ ...userData, name: e.target.value })}
        />
      </FormGroup>
      <FormGroup>
        <Label>{ t('auth.tabs.register.fields.phone_number.label') }: </Label>
        <Input 
          type="tel"
          inputMode="numeric"
          placeholder={ t('auth.tabs.register.fields.phone_number.placeholder') } 
          value={userData.phoneNumber}
          onChange={(e) => setUserData({ ...userData, phoneNumber: e.target.value })}
        />
      </FormGroup>
      <FormGroup className="mb-5">
        <Label>{ t('auth.tabs.register.fields.password.label') }: </Label>
        <Input 
          type="password" 
          placeholder={ t('auth.tabs.register.fields.password.placeholder') } 
          value={userData.password}
          onChange={(e) => setUserData({ ...userData, password: e.target.value })}
        />
        <div className="text-muted mt-2" style={{fontSize: 12}}>{ t('auth.tabs.register.fields.password.help_text') }</div>
      </FormGroup>
      <div className="text-center">
        <DefaultButton 
          color="primary" 
          onClick={register} 
          loading={isLoading}
          disabled={isLoading || !userData.name || userData.phoneNumber?.length < 8 || userData.password?.length < 8}
        >
          { t('auth.tabs.register.button') }
        </DefaultButton>
      </div>
    </div>
  );
}

export default RegisterForm;